const APP_ACTIONS = {
    LOGIN: "LOGIN",
    LOGOUT: "LOGOUT",
    MAKE_REPORT: "MAKE_REPORT",
}

export default APP_ACTIONS;